<app-card-list-item [routerLink]="['/inventory', 'transactions', transaction.id]">
  <div class="flex-1 px-4">
    <div class="text-sm font-medium">{{ transaction.transaction_type | titlecase }}</div>
    <div class="text-xs text-gray-600">{{ transaction.transaction_date | date:'short' }}</div>
  </div>
  <div class="flex-shrink-0 text-gray-500">
    <i class="fas fa-chevron-right"></i>
  </div>
</app-card-list-item>
